export enum ProposalStatusEnum {
    EmAnalise = 'EM_ANALISE',
    Aceita = 'ACEITA',
    Recusada = 'RECUSADA',
}

export enum ApoliceStatusEnum {
    Vigente = 'VIGENTE',
    Cancelada = 'CANCELADA'
}